
const initialState = {
    showLoader: false,
    heights: {
        headerHeight: 0,
        submenuHeight: 0,
        contentWrapPaddingTop: 32,
        contentWrapPaddingBottom: 16,
        contentHeaderHeight: 0,
        contentBodyHeight: 0,
        footerHeight: 0
    },
    asyncConfirm: {
        show: false,
        title: '',
        message: '',
        onConfirm: () => { },
        isConfirming: false,
        onDeny: () => { },
        isDenying: false
    }
}

const InterfaceReducer = (state = initialState, action: any) => {

    const st = { ...state }

    switch (action.type) {
        case 'INTERFACE_SHOW_LOADER':
            st.showLoader = true
            return st
        case 'INTERFACE_HIDE_LOADER':
            st.showLoader = false
            return st
        case 'INTERFACE_SET_HEIGHT':
            st.heights = { ...st.heights, [action.payload.key]: action.payload.value }
            return st
        case 'INTERFACE_ASYNC_CONFIRM_SHOW': {

            const { title, message, onConfirm, onDeny } = action.payload

            st.asyncConfirm = {
                show: true,
                title,
                message,
                onConfirm,
                onDeny,
                isConfirming: false,
                isDenying: false
            }
            return st
        }
        case 'INTERFACE_ASYNC_CONFIRM_SET_CONFIRMING': {

            st.asyncConfirm = {
                ...st.asyncConfirm,
                isConfirming: action.payload.isConfirming
            }
            return st
        }
        case 'INTERFACE_ASYNC_CONFIRM_SET_DENYING': {

            st.asyncConfirm = {
                ...st.asyncConfirm,
                isDenying: action.payload.isDenying
            }
            return st
        }
        case 'INTERFACE_ASYNC_CONFIRM_HIDE': {

        //   return {
        //     ...state,
        //     asyncConfirm: {
        //         ...state.asyncConfirm,
        //         show: false,
        //         title: '',
        //         message: '',
        //         onConfirm: () => { },
        //         onDeny: () => { },
        //         isConfirming: false,
        //         isDenying: false
        //     }
        //   }

            st.asyncConfirm = {
                ...state.asyncConfirm,
                show: false,
                title: '',
                message: '',
                onConfirm: () => { },
                onDeny: () => { },
                isConfirming: false,
                isDenying: false
            }
            return st
        }
        default:
            return { ...state }
    }
}

export default InterfaceReducer
